import React from 'react';

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Yasal Bilgiler
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">1. ŞİRKET BİLGİLERİ</h2>
            <div className="bg-gray-100 p-6 rounded-lg mb-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-lg font-semibold mb-3">Ticari Bilgiler</h3>
                  <p><strong>Ticaret Unvanı:</strong> Fiel Home</p>
                  <p><strong>Faaliyet Konusu:</strong> Mobilya ve Mobilya Aksesuarları Toptan Ticareti</p>
                  <p><strong>Ana Faaliyet Kodu:</strong> 464701</p>
                  <p><strong>Faaliyet Açıklaması:</strong> MOBİLYA VE MOBİLYA AKSESUARLARI TOPTAN TİCARETİ (YATAK DAHİL)</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-3">Vergi Bilgileri</h3>
                  <p><strong>Vergi Kimlik Numarası:</strong> 7661111486</p>
                  <p><strong>Vergi Dairesi:</strong> İnegöl Vergi Dairesi</p>
                  <p><strong>Vergi Levhası:</strong> Mevcut</p>
                </div>
              </div>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">2. ADRES BİLGİLERİ</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3">İş Yeri Adresi</h3>
                <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A</p>
                <p><strong>İlçe:</strong> İNEGÖL</p>
                <p><strong>İl:</strong> BURSA</p>
                <p><strong>Posta Kodu:</strong> 16400</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3">Mağaza Adresi</h3>
                <p><strong>Adres:</strong> Mahmudiye, Ankara Cd. No:90</p>
                <p><strong>İlçe:</strong> İnegöl</p>
                <p><strong>İl:</strong> Bursa</p>
                <p><strong>Posta Kodu:</strong> 16400</p>
              </div>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">3. İLETİŞİM BİLGİLERİ</h2>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <p><strong>Telefon:</strong> +90 552 229 90 07</p>
                  <p><strong>Çalışma Saatleri:</strong> Pzt-Cum 09:00-18:00</p>
                </div>
                <div>
                  <p><strong>E-posta:</strong> info@fielhome.com</p>
                  <p><strong>Destek:</strong> 7/24 Online Destek</p>
                </div>
                <div>
                  <p><strong>Web Sitesi:</strong> www.fielhome.com</p>
                  <p><strong>Sosyal Medya:</strong> @fielhome</p>
                </div>
              </div>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">4. E-TİCARET BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. Platform Bilgileri</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>E-ticaret platformu: www.fielhome.com</li>
              <li>Platform türü: B2C (İşletmeden Tüketiciye)</li>
              <li>Satış kanalları: Online satış, mağaza satışı</li>
              <li>Ödeme altyapısı: PayTR güvenli ödeme sistemi</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Güvenlik Sertifikaları</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>SSL Sertifikası: 256-bit şifrelemeli güvenli bağlantı</li>
              <li>PCI DSS Uyumluluğu: Ödeme kartı veri güvenliği standardı</li>
              <li>3D Secure: Ek güvenlik katmanı</li>
              <li>HTTPS Protokolü: Güvenli veri aktarımı</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">5. UYGULANACAK MEVZUAT</h2>
            <h3 className="text-lg font-semibold mb-3">5.1. Temel Mevzuat</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li><strong>6502 Sayılı Kanun:</strong> Tüketicinin Korunması Hakkında Kanun</li>
              <li><strong>6563 Sayılı Kanun:</strong> Elektronik Ticaretin Düzenlenmesi Hakkında Kanun</li>
              <li><strong>Mesafeli Sözleşmeler Yönetmeliği:</strong> (RG: 27.11.2014/29188)</li>
              <li><strong>Elektronik Ticaret Bilgi Sistemi Yönetmeliği:</strong> (RG: 15.05.2015/29355)</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">5.2. Veri Koruma Mevzuatı</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li><strong>6698 Sayılı Kanun:</strong> Kişisel Verilerin Korunması Kanunu (KVKK)</li>
              <li><strong>KVKK Yönetmelikleri:</strong> Veri işleme, silme ve anonim hale getirme</li>
              <li><strong>Çerez Aydınlatma Metni:</strong> İnternet sitesi kullanım bilgileri</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">6. TİCARİ FAALIYE BELGE BİLGİLERİ</h2>
            <div className="bg-yellow-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-semibold mb-3">6.1. Faaliyet Belgesi</h3>
              <p><strong>Ticaret Sicil Numarası:</strong> [Ticaret Sicil Kayıt Numarası]</p>
              <p><strong>Ticaret Odası:</strong> İnegöl Ticaret ve Sanayi Odası</p>
              <p><strong>Kayıt Tarihi:</strong> [Ticaret Sicil Kayıt Tarihi]</p>
              <p><strong>Oda Sicil No:</strong> [İnegöl TSO Sicil Numarası]</p>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">7. ÜRÜN VE HİZMET BİLGİLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">7.1. Satış Konusu Ürünler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Oturma Grubu Mobilyaları (Koltuk, berjer, puf)</li>
              <li>Yatak Odası Mobilyaları (Yatak, gardırop, komodin)</li>
              <li>Yemek Odası Mobilyaları (Masa, sandalye, vitrin)</li>
              <li>Ofis Mobilyaları (Masa, sandalye, dolap)</li>
              <li>Mobilya Aksesuarları ve Dekoratif Ürünler</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">7.2. Sunulan Hizmetler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Online mobilya satışı</li>
              <li>Ücretsiz teslimat hizmeti (belirli tutar üzeri)</li>
              <li>Montaj ve kurulum hizmeti</li>
              <li>Satış sonrası müşteri desteği</li>
              <li>Garanti ve teknik servis koordinasyonu</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">8. FİKRİ MÜLKİYET HAKLARI</h2>
            <p className="mb-4">
              www.fielhome.com internet sitesinde yer alan tüm içerik 
              (yazı, görsel, tasarım, logo, marka vb.) Fiel Home'a aittir ve 
              fikri mülkiyet hakları kapsamında korunmaktadır.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">8.1. Korunan İçerikler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Site tasarımı ve arayüzü</li>
              <li>Ürün fotoğrafları ve görselleri</li>
              <li>Yazılı içerik ve açıklamalar</li>
              <li>Logo ve marka unsurları</li>
              <li>Yazılım ve kodlama</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">9. SORUMLULUK REDDİ</h2>
            <h3 className="text-lg font-semibold mb-3">9.1. Teknik Sorumluluk Reddi</h3>
            <p className="mb-4">
              Fiel Home aşağıdaki durumlardan sorumlu değildir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>İnternet bağlantısı kesintilerinden kaynaklanan sorunlar</li>
              <li>Üçüncü kişi yazılımlarından kaynaklanan hatalar</li>
              <li>Siber saldırı ve güvenlik ihlalleri</li>
              <li>Kullanıcı hatalarından kaynaklanan veri kayıpları</li>
              <li>Mücbir sebeplerden kaynaklanan hizmet kesintileri</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">10. YETKİLİ MAHKEME VE İCRA DAİRESİ</h2>
            <p className="mb-4">
              İşbu sözleşmeden doğabilecek her türlü uyuşmazlığın çözümünde 
              <strong>İnegöl Mahkemeleri ve İcra Müdürlükleri</strong> yetkilidir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">11. GÜNCELLEMELER</h2>
            <p className="mb-4">
              Bu yasal bilgiler, yasal düzenlemelerdeki değişiklikler veya 
              operasyonel ihtiyaçlar doğrultusunda güncellenebilir. 
              Güncellemeler website üzerinden duyurulur.
            </p>
            
            <div className="mt-8 p-4 bg-red-50 border-l-4 border-red-400">
              <p className="text-sm text-red-800">
                <strong>UYARI:</strong> Bu sayfada yer alan bilgiler yasal 
                gereklilikler çerçevesinde hazırlanmıştır. Herhangi bir 
                uyumsuzluk durumunda güncel mevzuat esas alınır.
              </p>
            </div>
            
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-600">
                Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
              </p>
              <p className="text-xs text-gray-500 mt-2">
                Bu bilgiler 6563 sayılı Elektronik Ticaretin Düzenlenmesi 
                Hakkında Kanun gereğince hazırlanmıştır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
